import { Field } from 'formik'
import React from 'react'
import * as Bootstrap from 'react-bootstrap'

const InputDescripcion = ({ talento, errors, touched, index, esEditable }) => {
    return (
        <Bootstrap.Form.Group
            as={Bootstrap.Col}
            md="3"
            style={{
                display: `${esEditable(talento.talentoId) === true
                    ? "block"
                    : "none"
                    }`,
            }}
        >
            <Bootstrap.Form.Label>
                <strong>Descripcion</strong>
            </Bootstrap.Form.Label>
            <Field
                placeholder="Escribe la descripcion de tu talento..."
                className={`form-control ${errors?.personaTalentos?.[index]
                    ?.descripcion && "is-invalid"}`}
                name={`personaTalentos.${index}.descripcion`}
            />
        </Bootstrap.Form.Group>
    )
}

export default InputDescripcion